require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.freeze");

/**
 * A colorful logger for JS in Node and in the Browser
 *
 * Named after Hagen the colorful Lumberjack from Synthie Forest
 * https://vimeo.com/90995716
 *
 */
// ========= IMPORTS =========
var isBrowser = require("detect-browser").detect(); // eslint-disable-line quotes


var chalk = require("chalk"); // eslint-disable-line quotes
// ========= COLORS =========


var colorList = require("./utils/colors"); // eslint-disable-line quotes


var textColors = Object.freeze({
  LIGHT: colorList.gray[50],
  DARK: colorList.gray[900]
});
var reservedColors = Object.freeze({
  WARN: {
    bg: "#ccff00",
    text: textColors.DARK
  },
  ERROR: {
    bg: "#ff0099",
    text: textColors.LIGHT
  },
  INFO: {
    bg: "#000000",
    text: textColors.LIGHT
  }
});
var colors = [{
  bg: colorList.blue[500],
  text: textColors.LIGHT
}, // blue
{
  bg: colorList.red[500],
  text: textColors.LIGHT
}, // red
{
  bg: colorList.yellow[500],
  text: textColors.DARK
}, // yellow
{
  bg: colorList.green[500],
  text: textColors.LIGHT
}, // green
{
  bg: colorList.orange[500],
  text: textColors.LIGHT
}, // orange
{
  bg: colorList.pink[500],
  text: textColors.LIGHT
}, // pink
{
  bg: colorList.purple[500],
  text: textColors.LIGHT
}, // purple
{
  bg: colorList.cyan[500],
  text: textColors.DARK
} // cyan
]; // ========= HELPERS =========
// Writes to console colored text, from the passed-in logger

function logg(logger, color, label, message) {
  if (isBrowser.name === "node") {
    // if using node.js
    switch (typeof message) {
      case "object":
        // if the message is an object
        logger(chalk.bgHex(color.bg).hex(color.text).bold(" ".concat(label, " ")), "".concat(JSON.stringify(message)));
        break;

      case "undefined":
        // if there is no message
        logger(chalk.bgHex(color.bg).hex(color.text).bold(" ".concat(label, " ")));
        break;

      default:
        logger(chalk.bgHex(color.bg).hex(color.text).bold(" ".concat(label, " ")), "".concat(message));
        break;
    }
  } else {
    // if using the browser
    switch (typeof message) {
      case "object":
        // if the message is an object
        logger("%c ".concat(label, " %c %o"), "\n\t\t\t\t\t\tbackground-color: ".concat(color.bg, "; \n\t\t\t\t\t\tcolor: ").concat(color.text, "; \n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t"), "\n\t\t\t\t\t\tbackground-color: inherit; \n\t\t\t\t\t\tcolor: inherit; \n\t\t\t\t\t\tfont-weight: inherit;\n\t\t\t\t\t", message);
        break;

      case "undefined":
        // if there is no message
        logger("%c ".concat(label, " "), "\n\t\t\t\t\t\tbackground-color: ".concat(color.bg, "; \n\t\t\t\t\t\tcolor: ").concat(color.text, "; \n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t"));
        break;

      default:
        logger("%c ".concat(label, " %c ").concat(message), "\n\t\t\t\t\t\tbackground-color: ".concat(color.bg, "; \n\t\t\t\t\t\tcolor: ").concat(color.text, "; \n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t"), "\n\t\t\t\t\t\tbackground-color: inherit; \n\t\t\t\t\t\tcolor: inherit; \n\t\t\t\t\t\tfont-weight: inherit;\n\t\t\t\t\t");
        break;
    }
  }
} // ========= LOGGERS =========
// basic logger


function log(label, message, manualColor) {
  // if the label isn't a string
  if (typeof label !== "string") label = ""; // checks if a color id was passed in and sets the color

  var color;
  var numColors = colors.length;

  if (typeof manualColor === "number" && manualColor >= 0) {
    // if it was with an integer, use that as the color id
    // round floats to the nearest integer
    color = colors[Math.round(manualColor) % numColors];
  } else if (typeof manualColor === "object" && manualColor.bg !== undefined && manualColor.text !== undefined) {
    // if it was with a custom color object, use that
    color = {
      bg: manualColor.bg,
      text: manualColor.text
    };
  } else {
    // if it wasn't, use a value generated from the label
    var val = 0;
    label.split("").forEach(function (character) {
      val += character.charCodeAt(0);
    });
    color = colors[val % numColors];
  }

  logg(console.log, color, label, message);
} // info logger


function info(label, message) {
  logg(console.log, reservedColors.INFO, "i ".concat(label), message);
} // warning logger


function warn(label, message) {
  logg(console.warn, reservedColors.WARN, "! ".concat(label), message);
} // error logger


function error(label, message) {
  logg(console.error, reservedColors.ERROR, "\u2715 ".concat(label), message);
} // ========= GROUPS =========


function group() {
  console.group();
}

function groupCollapsed() {
  console.groupCollapsed();
}

function groupEnd() {
  console.groupEnd();
} // ========= EXPORTS =========


module.exports = {
  log: log,
  info: info,
  warn: warn,
  error: error,
  group: group,
  groupCollapsed: groupCollapsed,
  groupEnd: groupEnd
};